import { observable, action, decorate } from 'mobx';
import formatPhone from '../logic/FormatPhone';
import { addCustomDatadogError } from '../utils/datadog';
import Fetch from '../fetch/Fetch';
import {
  ReturnAccountSettingsResponse,
  ReturnsSupportDetails,
} from '../fetch/types';

interface Config extends ReturnsSupportDetails {
  isValid?: boolean;
}

class ConfigStore {
  public config: Config = {};

  transport: Fetch | null = null;

  constructor(transport: Fetch) {
    this.transport = transport;
  }

  set(config: Config) {
    this.config = config;
    if (this.getSupportPhone()) {
      this.setSupportPhone(formatPhone(this.getSupportPhone()!));
    } else {
      this.setSupportPhone(null);
    }
  }

  setSupportPhone(phone: string | null) {
    this.config.customer_support_phone = phone;
  }

  getSupportEmail() {
    return this.config.customer_support_email;
  }

  getSupportPhone() {
    return this.config.customer_support_phone;
  }

  getReturnPolicyUrl() {
    return this.config.return_policy_url!;
  }

  isReturnPolicyMissing() {
    return !this.config.return_policy_url;
  }

  isNotValidMerchant() {
    return this.config.isValid === false;
  }

  async fetchAccountSettings(merchantReference: string) {
    try {
      const json = (await this.transport!.getReturnAccountSettings(
        merchantReference
      )) as ReturnAccountSettingsResponse;
      return this.set(json.returns_support_details);
    } catch (error) {
      this.set({ isValid: false });

      addCustomDatadogError(
        `Fetch account setting: issue while fetching account setting for merchant reference: ${merchantReference}`,
        error
      );
    }
    return undefined;
  }
}

decorate(ConfigStore, {
  config: observable,
  set: action,
});

export default ConfigStore;
